var map = {
	"./doc.png": 1225,
	"./docx.png": 1226,
	"./flv.png": 1227,
	"./html.png": 1228,
	"./jpeg.png": 1229,
	"./jpg.png": 1230,
	"./mkv.png": 1231,
	"./mp3.png": 1232,
	"./pdf.png": 562,
	"./png.png": 1233,
	"./ppt.png": 1234,
	"./pptx.png": 1235,
	"./rtf.png": 1236,
	"./swf.png": 1237,
	"./txt.png": 791,
	"./url.png": 1238,
	"./xls.png": 1239,
	"./xlsx.png": 1240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1224;